import {BasicCriteria} from '../../../allkey/framework/parameters/BasicCriteria';

export class MeasureCriteria extends BasicCriteria {
visionCode: string;
visionCodeList: string[];
}

